<template>
  <div>
    <article>
      <section>
        <div class="courseUnits_dialogs">
          <el-dialog
            :title="`Update A Banner`"
            :visible.sync="isEditBannerModalVisible"
            :destroy-on-close="true"
            :before-close="handleClose"
            style="text-align: left"
          >
            <div v-loading="submitting">
              <el-form
                :model="bannerForm"
                :rules="rules"
                label-position="top"
                ref="bannerForm"
                class="demo-bannerForm2"
              >
                <div class="row">
                  <div class="col-md-12">
                    <el-form-item
                      label="banner Title"
                      prop="banner_title"
                    >
                      <el-input v-model="bannerForm.banner_title"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <el-form-item
                      label="banner Brief Description"
                      prop="banner_brief_description"
                    >
                      <el-input v-model="bannerForm.banner_brief_description"></el-input>
                    </el-form-item>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <el-form-item label="User Photo">
                      <el-upload
                        class="upload-demo"
                        drag
                        action="''"
                        :on-change="handleBannerPhotoPreview"
                        :on-remove="handleUserPhotoPreview"
                        :file-list="bannerPhotoFileLists"
                        :auto-upload="false"
                        :multiple="false"
                      >
                        <div v-if="!isUploadingFile">
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            Drop file here or <em>click to upload</em>
                          </div>
                        </div>
                        <div v-else>
                          <el-progress
                            v-if="imageUploadingProgress != 100"
                            type="circle"
                            :color="progressColors"
                            :percentage="imageUploadingProgress"
                            :width="80"
                            :stroke-width="4"
                          ></el-progress>
                          <el-progress
                            v-else
                            type="circle"
                            :percentage="100"
                            status="success"
                            :width="80"
                            :stroke-width="4"
                          ></el-progress>
                          <div style="font-size: 0.8em; color: rgba(0, 0, 0, 0.8)">
                            {{
                          imageUploadingProgress == 100
                            ? "Uploaded"
                            : "Uploading..."
                        }}
                          </div>
                        </div>
                        <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
                      </el-upload>
                    </el-form-item>
                  </div>
                </div>

                <hr />
                <el-form-item class="text-center">
                  <el-button
                    style="background-color: #083628; color: white;"
                    @click="editBanner('bannerForm')"
                  > Save Banner Changes</el-button>
                </el-form-item>
              </el-form>

              <div class="text-center">
                <div class="text-center">
                  <small>© 2024 Acacia Wilderness Mweya, All rights reserved.</small>
                </div>
                <div class="text-center">
                  <!--v-model="bannerForm.Course" <small>Design by <a href="https://ovalspace.co" style="color: black;"><strong>Ovalspace</strong></a></small> -->
                </div>
              </div>
            </div>
          </el-dialog>
        </div>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoading: false,
      bookings: [],
      selectedBannerPhotoFile: null,
      isUploadingFile: false,
      imageUploadingProgress: 0,
      progressColors: [
        { color: "#f56c6c", percentage: 25 },
        { color: "#e6a23c", percentage: 50 },
        { color: "#1989fa", percentage: 75 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      // bannerPhotoFileLists: [],
      bannerPhotoFileLists: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "food2.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],

      addUserModal: false,
      isEditBannerModalVisible: false,
      years: "",
      year_numbers: [],
      value: "",
      loadingError: false,
      submitting: false,
      course: "",
      bannerForm: {
        banner_title: "",
        banner_brief_description: "",
      },

      rules: {
        banner_title: [
          {
            required: true,
            message: "First Name is required",
            trigger: "blur",
          },
        ],
        banner_brief_description: [
          {
            required: true,
            message: "banner Brief Description is required",
            trigger: "blur",
          },
        ],
      },
    };
  },

  props: {
    showUserEditDialog: {
      required: true,
      type: Boolean,
    },
    bannerData: {
      required: true,
      type: Object,
    },
  },

  watch: {
    showUserEditDialog() {
      if (this.showUserEditDialog === true) {
        this.isEditBannerModalVisible = true;
        this.bannerForm.banner_title = this.bannerData.banner_title;
        this.bannerForm.banner_brief_description = this.bannerData.banner_brief_description;
        this.selectedBannerPhotoFile = this.bannerData.banner_image;
        this.bannerPhotoFileLists = [
          {
            name: "banner_image",
            url: "this.bannerData.banner_image",
          },
        ];
      } else {
        this.isEditBannerModalVisible = false;
      }
    },
  },

  methods: {
    handleClose(done) {
      done();
      this.$emit("closeEditBannerDialog");
    },

    handleBannerPhotoPreview(file) {
      console.log(file.raw);
      this.bannerPhotoFileLists = [file];
      this.selectedBannerPhotoFile = file.raw;
    },
    handleUserPhotoPreview() {
      this.selectedBannerPhotoFile = null;
    },

    showAddUserModal() {
      this.addUserModal = true;
      this.getCountries();
    },

    async editBanner(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.submitting = true;
            this.isUploadingFile = true;
            const formData = new FormData();
            formData.append("banner_title", this.bannerForm.banner_title);
            formData.append(
              "banner_brief_description",
              this.bannerForm.banner_brief_description
            );
            formData.append("banner_image", this.selectedBannerPhotoFile);
            let response = await this.$http.patch(
              `banners/${this.bannerData.banner_id}`,
              formData,
              {
                onUploadProgress: (progressEvent) => {
                  this.imageUploadingProgress = +(
                    (progressEvent.loaded / progressEvent.total) *
                    100
                  ).toFixed(0);
                },
              }
            );
            if (
              response.data.success &&
              response.data.message == "BANNER_UPDATED_SUCCESSFULLY"
            ) {
              this.$refs[formName].resetFields();
              this.$emit("re-fresh");
              this.$notify({
                title: "Success",
                message: "Banner updated successfully",
                type: "success",
              });
              this.$emit("closeEditBannerDialog");
            } else {
              throw "UNEXPECTED_RESPONSE";
            }
          } catch (error) {
            if (error.message == "Network Error") {
              return this.$notify({
                title: "Connection failed",
                message: "A network error occurred, please try again.",
                type: "error",
              });
            }
            this.$notify({
              title: "Unable to update Banner",
              message: "An unexpected Error occurred, please try again",
              type: "error",
            });
          } finally {
            this.submitting = false;
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>